import axios from "axios"

export default class Axios {
  constructor(store) {
    this.axios = axios.create({
      baseURL: process.env.MIX_API_DOMAIN,
      headers: {"X-Requested-With": "XMLHttpRequest"}
    })

    this.requestInterceptor = null
    this.setToken(store.getters["auth/token"])
  }

  /**
   * @param {string} endpoint
   * @param {object} queries
   * @returns {Promise<AxiosResponse<any>>}
   */
  get(endpoint, queries = {}) {
    return this.axios.get(endpoint, {params: queries})
  }

  /**
   * @param {string} endpoint
   * @param {object} inputs
   * @returns {Promise<AxiosResponse<any>>}
   */
  post(endpoint, inputs = {}) {
    return this.axios.post(endpoint, inputs)
  }

  /**
   * @param {string} endpoint
   * @param {object} inputs
   * @returns {Promise<AxiosResponse<any>>}
   */
  put(endpoint, inputs = {}) {
    return this.axios.put(endpoint, inputs)
  }

  /**
   * @param {string} endpoint
   * @param {object} inputs
   * @returns {Promise<AxiosResponse<any>>}
   */
  patch(endpoint, inputs = {}) {
    return this.axios.patch(endpoint, inputs)
  }

  /**
   * @param {string} endpoint
   * @returns {Promise<AxiosResponse<any>>}
   */
  delete(endpoint) {
    return this.axios.delete(endpoint)
  }

  /**
   * Bearerトークンの設定
   * @param {string} token
   * @returns void
   */
  setToken(token) {
    if (!token) return

    this.requestInterceptor = this.axios.interceptors.request.use(
      config => {
        config.headers.common = {
          ["Authorization"]: `Bearer ${token}`,
          ["Accept"]: "application/json"
        }

        return config
      },
      error => {
        return Promise.reject(error)
      }
    )
  }

  /**
   * Bearerトークンの破棄
   * @returns void
   */
  resetToken() {
    this.axios.interceptors.request.eject(this.requestInterceptor)
  }
}
